import script from "./ScanUploader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScanUploader.vue?vue&type=script&setup=true&lang=ts"

import "./ScanUploader.vue?vue&type=style&index=0&id=2ca72622&scoped=true&lang=css"

import exportComponent from "/home/runner/work/uup/uup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ca72622"]])

export default __exports__